<template>
  <div class="container">
    <div class="application-info-container">
      <div class="application-info-top">
        <div class="application-info-top-header">采购申请信息</div>
        <div class="application-info-top-content-container">
          <el-form :inline="true" style="width: 100%" label-width="150px">
            <el-row style="margin-bottom: 0">
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="物料编码："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.materielCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物料名称：">
                  <e-tooltip
                    :content="purchaseInfo.productName"
                    :set-length="20"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="采购数量："
                  class="base-detail"
                  style="margin-bottom: 0"
                  >{{
                    Number(purchaseInfo.remainingQuantity) > 0
                      ? purchaseInfo.remainingQuantity
                      : purchaseInfo.intqty
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item label="要求交货日期：">
                  {{
                    purchaseInfo.expectedArrivalDate
                      ? purchaseInfo.expectedArrivalDate.split(' ')[0]
                      : ''
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="仓储地点：">
                  <e-tooltip
                    :content="purchaseInfo.warehouse"
                    :set-length="9"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采购申请计量单位：">
                  <e-tooltip :content="purchaseInfo.unitName" :set-length="9" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="application-info-middle">
        <div class="application-info-middle-header">
          <div>商品选择</div>
          <div>
            根据筛选条件，为贵公司推荐
            <span>{{ queryParams.total }}</span>
            件商品
          </div>
        </div>
        <div class="scroller_right">
          <span style="width: 80px; margin-left: 20px"> 综合搜索：</span>
          <el-input
            v-model="searchValue"
            class="scroller_input"
            size="middle"
            placeholder="提示：您可尝试搜索供应商、商品名称、品牌、规格型号等信息"
            @keyup.enter.native="goToSearch()"
          ></el-input>
          <p class="scroller_btn" @click="goToSearch">搜 索</p>

          <div>
            <el-checkbox v-model="showPurchasedFlag" @change="showPurchased()">
              仅展示已购商品
            </el-checkbox>
            <el-checkbox v-model="agreementPriceSign" @change="showPurchased()">
              仅展示协议商品
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="application-info-bottom">
        <el-table
          :header-cell-style="{ color: '#333', background: '#f5f5f5' }"
          :data="productList"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="date"
            label="商品信息"
            width="340"
          >
            <template slot-scope="scope">
              <div class="product-info">
                <!-- v-lazy="scope.row.defaultimage" -->
                <img class="product-img" :src="scope.row.defaultimage" alt />
                <!--              <img class="product-img-icon" src="~/assets/images/5.png" alt="">-->
                <div class="product-info-right">
                  <div
                    v-if="scope.row.skuname.length < 48"
                    class="title two-line"
                  >
                    {{ scope.row.skuname }}
                  </div>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="scope.row.skuname"
                    placement="top"
                  >
                    <div class="title two-line">{{ scope.row.skuname }}</div>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.skucode"
                    placement="bottom"
                  >
                    <div class="num break">
                      单品编号：{{ scope.row.skucode }}
                    </div>
                  </el-tooltip>
                  <div class="provider">
                    供应商：{{ scope.row.suppliercompanyname }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="brandname"
            label="品牌"
            width="100"
          ></el-table-column>
          <el-table-column align="center" prop="delivertime" label="发货时间">
            <template slot-scope="scope">
              <div>{{ scope.row.delivertime }}天内发货</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="unitvalue"
            label="单位"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="pricetypedescribe"
            label="价格类型"
          ></el-table-column>
          <el-table-column align="center" label="含税价格（元）">
            <template slot-scope="scope">
              <div
                v-if="scope.row.price && scope.row.pricetype === 4"
                class="jc-price-container"
              >
                <img
                  height="20"
                  width="44"
                  src="../../../../assets/img/product/together-price-icon-small@2x.png"
                  alt="集采价"
                />
                <div class="jc-price">
                  ￥
                  <span>{{ scope.row.price.toFixed(2) }}</span>
                </div>
              </div>
              <span v-else style="color: #f0250f; font-weight: bold">
                ￥{{ Number(scope.row.price).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <div class="select-btn" @click="selectBtn(scope.row)">选中</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryParams.pageNum"
          :total="queryParams.total"
          :page-size.sync="queryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 还未维护计量单位提示 -->
    <e-dialog
      :dialog-title="dialogTitle"
      :dialog-type="''"
      :center-dialog-visible="unitVisible"
      :popup-width="'450px'"
      :show-close="false"
      @submitPopupData="submitPopupData"
      @updateVisible="unitVisible = false"
      @resetPopupData="unitVisible = false"
    >
      <div>您好，所选商品计量单位关系转换还未维护，是否手工维护？</div>
    </e-dialog>
    <!-- 新增计量单位 -->
    <e-dialog
      :dialog-title="addDialogTitle"
      :dialog-type="''"
      :center-dialog-visible="addUnitVisible"
      :popup-width="'500px'"
      :show-close="false"
      @submitPopupData="addPopupData('form')"
      @resetPopupData="handleClose"
    >
      <el-form ref="form" :rules="rules" :model="unitForm" label-width="130px">
        <el-form-item label="采购商计量单位：">
          <el-input v-model="unitForm.purchaseUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="易派客计量单位：">
          <el-input v-model="unitForm.epecUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="转换比例：" prop="proportion">
          <div class="proportion-unit">
            {{ `(${unitForm.purchaseUnit}：${unitForm.epecUnit})` }}
          </div>
          <el-input
            v-model="unitForm.proportion"
            autocomplete="off"
            clearable
            placeholder="请输入转换比例"
            @blur="blurInput($event)"
            @input="limitInput($event, 'proportion')"
          ></el-input>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';
import priceSheet from '@/modules/projectA/components/purchase/pirce-sheet.vue';
import { customCategoriesList } from '@/modules/projectA/api/urlConfig';
import Api from '@/modules/projectA/api/purchase';
import enApi from '@/modules/projectA/api/enquiry';
import menuList from './components/header-menu.vue';
// var qs = require('qs');
export default {
  components: {
    eDialog,
    priceSheet,
    menuList,
    eTooltip,
  },
  data() {
    return {
      customCategoriesList,
      breadData: [
        { id: 1, name: '我的采购申请', path: '/fusePurchaseRequest' },
        { id: 2, name: '选择商品', path: '' },
      ],
      logoImg: '',
      showPurchasedFlag: false,
      agreementPriceSign: false,
      isShowPriceSheet: false,
      isCurrent: null,
      top: '-38px',
      left: '-530px',
      searchValue: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      formLabelAlign: {
        name: '',
        region: '',
        type: '',
        test: '',
      },
      unitForm: {
        purchaseUnit: '',
        epecUnit: '',
        proportion: '',
      },
      allCategoriesList: [],
      purchaseRequisitionId: '',
      productList: [],
      productSearch: {
        skuname: '', // 精确查询
        searchtext: '', // 模糊查询
        brandname: '', // 品牌
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        companyName: '', // 供应商
        unitvalue: '', // 筛选条件
        pageNum: 1,
        pageSize: 10,
      },
      purchaseInfo: Object,
      oldSkuIdList: [],
      prPurchasLlistVOs: [],
      dialogTitle: '计量单位关系转换',
      addDialogTitle: '新增计量单位转换',
      unitVisible: false,
      addUnitVisible: false,
      rules: {
        proportion: [
          { required: true, message: '请输入转换比例', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.purchaseRequisitionId = this.$route.query.purchaseRequisitionId;
    // this.productSearch.skuname = this.$route.query.prodname;
    this.queryPurchaseRequestDetail();
    if (this.purchaseRequisitionId) {
      this.queryPurchaseRequestDetail();
    }
    this.purchaseAreaCategory();
  },
  methods: {
    showPurchased() {
      this.queryProductPage();
    },
    // 搜索
    goToSearch() {
      // if (this.searchValue.trim() == "") {
      //   this.$message.warning('请输入搜索词');
      //   return
      // }
      // if (this.searchValue.trim().length > 100) {
      //   this.$message.warning('搜索词不能超过100个字');
      //   return
      // }
      this.productSearch.searchtext = this.searchValue;
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.queryProductPage();
    },
    resetBtn() {
      this.productSearch = {
        skuname: '',
        brandname: '', // 品牌
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        companyName: '', // 供应商
        // unitvalue: this.purchaseInfo.epecBaseUnitName ?  this.purchaseInfo.epecBaseUnitName :'',
        unitvalue: '',
        pageNum: 1,
        pageSize: 10,
      };
    },
    toBack() {
      this.$router.push({ path: `/fusePurchaseRequest` });
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.queryProductPage();
    },
    handleSizeChange(val) {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = val;
      this.queryProductPage();
    },
    onSubmit() {},
    async queryPurchaseRequestDetail() {
      const res = await Api.queryProcurementPlanDetail({
        purchaseRequisitionId: this.purchaseRequisitionId,
      });
      if (res.code == '200') {
        this.purchaseInfo = res.data;
        //  if(res.data.epecBaseUnitName){
        //    this.productSearch.unitvalue = res.data.epecBaseUnitName;
        //  }
      }
      this.queryProductPage();
    },
    async queryProductPage() {
      // 协议选择协议商品
      if (
        this.purchaseInfo.protocolType == 0 ||
        this.showPurchasedFlag ||
        this.agreementPriceSign
      ) {
        // 0：必须执行框架协议 1：可不执行框架协议
        const param = {
          materialCode: this.purchaseInfo.materielCode, // 必填
          negotiatedSign: this.purchaseInfo.protocolType ? 1 : 0, // 必填 1-全平台，0-框架协议
          purchasedSign: this.showPurchasedFlag ? 1 : 0, // 必填 0:未选 1：已选
          agreementPriceSign: this.agreementPriceSign ? 1 : 0,
          purchaserId: this.purchaseInfo.purchaseCompanyId, // 必填
          searchtext: this.productSearch.searchtext,
          isPurchaseControl:
            Number(this.$store.state.isProtocol) === 62 ? 1 : 0,
          ...this.queryParams,
        };

        const res = await Api.queryZoneProductPage(param);
        if (res.code == '200') {
          this.productList = res.data.list;
          this.queryParams.total = res.data.total;
        }
      } else {
        const res = await enApi.queryProductPage({
          ...this.productSearch,
          ...this.queryParams,
        });
        if (res.code == '200') {
          this.productList = res.data.list;
          this.queryParams.total = res.data.total;
        }
      }
    },
    // 选中 参考
    async selectProduct(data) {
      const detailInfoRes = await Api.getProtocolNo({
        skuId: data.skuid,
        supplierCompanyId: data.suppliercompanyid,
      });

      this.unitForm.purchaseUnit = this.purchaseInfo.unitName;
      this.unitForm.epecUnit = data.unitvalue;
      const rateInfo = await Api.getProductRate({ taxRateId: data.taxrateid });
      const params = {
        price: data.price,
        purchaseRequisitionId: this.purchaseRequisitionId,
        productId: data.productid,
        productImageUrl: data.defaultimage,
        productSkuCode: data.skucode, // 单品编号
        productSkuId: data.skuid, // 单品id
        productSkuName: data.skuname,
        productSkuOptions: data.specifications,
        productSkuOptionsStr: data.specifications,
        salesPropertyInfoAOList: data.specificationsList
          ? this.assembleCartParams(
              data.specificationsList,
              'salesPropertyInfoName',
              'salesPropertyInfoValue'
            )
          : [],
        quantity: 1,
        salesTaxNo: rateInfo.data.taxRateCode, // 税率
        salesTaxRate: parseFloat(rateInfo.data.taxRate), // 税码
        supplierCompanyName: data.suppliercompanyname,
        supplierCompanyId: data.suppliercompanyid,
        baseUnitName: data.unitvalue,
        baseUnitNo: data.unitId, // 单位id
        goodsUnitName: data.unitvalue,
        goodsUnitNo: data.unitId,
        protocolCode:
          detailInfoRes.data && detailInfoRes.data.length > 0
            ? detailInfoRes.data[0]
            : '',

        // brandName: data.brandname,
        // categoryId: data.thirdcategorycode,//类目id
        // categoryName: data.thirdcategory,//类目名称
        // convertNumber: 1,
        // inherentPropertyAOList: data.attributesList ? this.assembleCartParams(data.attributesList, 'inherentPropertyName', 'inherentPropertyValue') : [],
        // materNo: "",
        // productTypeId: "",
        // productTypeName: "",
        // sinoProtocol: "",//协议号
        // taxName: rateInfo.data.taxRateDes,//可以为空
      };
      if (data.pricetype === 4) {
        const agrParams = {
          skuId: data.skuid,
          supplierCompanyId: data.suppliercompanyid,
          priceType: 4,
        };
        const result = await Api.queryAgreementCodeByType(agrParams);
        if (result.code === '200') {
          const [newAgreementCode] = result.data;
          params.protocolCode = newAgreementCode;
          params.priceType = data.pricetype;
        }
      }
      const res = await Api.selectPurchasePlanProduct(params);
      if (res.code == '200') {
        this.$message.success('商品成功选中。');
        this.$router.push('/fusePurchaseRequest');
      } else if (res.code == '4089') {
        this.unitVisible = true;
      }
    },
    // 组装加入购物车规格属性参数
    assembleCartParams(arr, name, value) {
      // console.log(arr);
      const res = [];
      if (arr.length == 0) return res;
      for (let i = 0; i < arr.length; i++) {
        const temObj = {};
        const index = arr[i].indexOf('_');
        temObj[name] = arr[i].substr(0, index);
        temObj[value] = arr[i].substr(index + 1);
        res.push(temObj);
      }
      // console.log(res);
      return res;
    },
    changePriceSheetShow(index) {
      this.$set(this.productList[index], isShowPriceSheet, true);
    },
    changePriceSheetHidden(index) {
      this.$set(this.productList[index], isShowPriceSheet, false);
    },
    selectBtn(data) {
      this.selectProduct(data);
    },

    // 手动维护计量单位
    submitPopupData() {
      this.unitVisible = false;
      this.addUnitVisible = true;
    },

    handleClose() {
      this.addUnitVisible = false;
      this.$refs.form.resetFields();
    },

    blurInput(e) {
      const val = e.target.value;
      if (val == 0) {
        this.unitForm.proportion = '';
      }
    },
    limitInput(value, name) {
      this.unitForm[name] =
        `${value}` // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,4})/g)[0] || ''; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到4位小数
    },
    // 新增计量单位转换
    addPopupData(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const params = {
            sourceUnit: this.unitForm.purchaseUnit,
            targetUnit: this.unitForm.epecUnit,
            conversionRatio: this.unitForm.proportion,
            companyId: this.$store.state.USERINFO.companyId,
            companyName: this.$store.state.USERINFO.companyName,
            sysNo: this.$store.state.USERINFO.internalCode,
          };
          Api.addConversionUnit(params).then((res) => {
            if (res.code == '200') {
              this.addUnitVisible = false;
              this.$message.success('提交成功');
              this.queryPurchaseRequestDetail();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取已设置分类
    async purchaseAreaCategory() {
      const params = {
        companyId: this.$store.state.USERINFO.purchaseAreaCompanyId,
      };
      const res = await Api.purchaseAreaCategory(params);
      if (res.data.categoryList) {
        this.allCategoriesList = res.data.categoryList;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/css/theme.scss';
::v-deep .jc-price-container {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  img {
    position: relative;
    z-index: 1;
  }
  .jc-price {
    height: 18px;
    padding: 0 10px 0 20px;
    margin-left: -20px;
    align-self: flex-end;
    background: #ffeac9;
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    color: #f0250f;
  }
}
.classification-wrapper {
  position: relative;
}
.classification {
  position: relative;
  .classification-content {
  }
}
.classification-wrapper:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: $main-col;
  z-index: 1;
}
.application-info-container {
  color: $font-color-text;
  margin-bottom: 20px;
  ::v-deep .el-input__inner {
    color: #333;
  }

  .application-info-top {
    margin-bottom: 20px;

    .application-info-top-header {
      font-weight: bold;
      padding-left: 20px;
      height: 40px;
      border: 1px solid #d9d9d9;
      border-bottom: none;
      line-height: 40px;
      color: $font-color-text;
      background-color: $main-table-th-bg;
      box-sizing: border-box;
    }

    .application-info-top-content-container {
      padding: 20px;
      border: 1px solid $border-color;
      box-sizing: border-box;
    }
  }
  .application-info-middle {
    margin-bottom: 20px;
    border: 1px solid $border-color;
    box-sizing: border-box;

    .application-info-middle-header {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #d9d9d9;
      color: $font-color-text;
      background: $main-table-th-bg;
      box-sizing: border-box;

      div:nth-child(1) {
        font-weight: bold;
      }

      span {
        color: $headline-color-num;
      }
    }
    .scroller_right {
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      font-size: 14px;
      ::v-deep .el-input {
        width: 200px;
        border-radius: 0;
      }
      .scroller_input {
        width: 514px;
        ::v-deep.el-input__inner {
          border: 1px solid $main-col;
          border-right: none;
          border-radius: 0;
          height: 34px;
          line-height: 34px;
          font-size: 12px;
        }
      }
      .scroller_btn {
        width: 100px;
        height: 34px;
        line-height: 30px;
        background: #2587ff;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border: 2px solid $main-col;
        margin-right: 20px;
        &:hover {
          background-color: #126edf;
          border-color: #126edf;
        }
      }
    }
    .application-info-middle-content-container {
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 0 38px;
      box-sizing: border-box;

      .application-info-middle-content-left {
        flex: 0 1 924px;

        ::v-deep .el-form {
          margin-top: -14px;
          .el-form-item {
            margin-bottom: 0;
            .el-form-item__content {
              .el-col {
                .el-input {
                  input {
                    width: 190px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .application-info-middle-content-right {
      display: flex;
      justify-content: center;
      margin: 7px 0 10px 0;
      .reset-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #e8efff;
        color: #2587ff;
        cursor: pointer;
        border: 1px solid #2587ff;
        margin-right: 20px;
        &:hover {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #2587ff;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background-color: #126edf;
        }
      }
    }
  }
  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .back {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }
    .margin {
      margin-top: 20px;
    }
  }
  .application-info-bottom {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;

    ::v-deep .el-table {
      .product-info {
        position: relative;
        display: flex;
        align-items: center;
        width: 340px;

        .product-img {
          width: 88px;
          height: 88px;
          border: 1px solid #e2e2e2;
          box-sizing: border-box;
        }

        .product-img-icon {
          position: absolute;
          top: 11px;
          left: 6px;
          width: 20px;
          height: 20px;
        }

        .product-info-right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          > div {
            align-self: flex-start;
          }

          .title {
            width: 220px;
            text-align: left;
            color: #333333;
          }

          .num {
            font-size: 12px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 231px;
          }

          .provider {
            font-size: 12px;
            color: #666666;
          }

          .footer {
            display: flex;
            justify-content: flex-start;

            p {
              width: 48px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #ffffff;
              margin-left: 10px;
              border-radius: 5px;
              font-size: 12px;
            }

            .authenticated {
              background-color: $button-background-color;
            }

            .easy-all-pass {
              background-color: $button-background-color2;
            }
          }
        }
      }

      .select-btn {
        width: 80px;
        height: 30px;
        line-height: 26px;
        color: #2587ff;
        border: 1px solid #2587ff;
        background-color: #fff;
        cursor: pointer;
        margin-left: 12px;
        &:hover {
          background-color: #2587ff;
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-table .cell {
  overflow: visible;
}

.step-price {
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: center;
  &:hover {
    .price-sheet {
      display: inline-block;
    }
  }
  cursor: pointer;
  img {
    width: 45px;
    margin: 0 4px 0 8px;
  }
  .icon-question {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    .icon-question {
      background: #c5c5c5;
      color: #fff;
    }
  }
}
::v-deep .el-input__inner {
  border-radius: 0;
}
::v-deep .el-form-item__content {
  position: relative;
}
.proportion-unit {
  position: absolute;
  left: -140px;
  top: 28px;
  width: 120px;
  height: 30px;
  text-align: right;
  word-wrap: break-word;
  word-break: break-all;
  line-height: normal;
}
.pagination-box {
  text-align: right;
}
</style>
